import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router";
import AppText from "../../components/Core/AppText/AppText";
import { routes } from "../../configs/constants/routes";
import { useAuthStore } from "../../stores/auth.store";

const LogoutPage: React.FC = () => {
	const authStore = useAuthStore();
	const { t } = useTranslation();

	useEffect(() => {
		useAuthStore.getState().logout();
	}, []);

	if (authStore.isLoggedIn)
		return (
			<AppText textAlign="center" margin="1rem">
				{t("LOGGING_OUT")}
			</AppText>
		);

	return <Navigate replace to={routes.LOGIN} />;
};

export default LogoutPage;
